import { FC } from "react";
import { useTranslation } from "react-i18next";
import Carrier from "src/components/Carrier/Carrier";
import RechargeTriggerButton from "./RechargeTriggerButton";
import RechargeConfirmation, { RechargeValues } from "./RechargeConfirmation";
import RechargeResultStep from "./RechargeResultStep";

type Props = RechargeValues & {
  triggerLabel?: string;
  isLoading: boolean;
  error: any;
  data: any;
  handleSubmit: () => void;
  handleCancel: () => void;
  handleBack: () => void;
};

const RechargeButtonMob: FC<Props> = ({ triggerLabel, isLoading, error, data, handleSubmit, handleCancel, handleBack, ...summary }) => {
  const { t } = useTranslation();
  const hasResult = !!error || !!data;

  return (
    <Carrier
      label={t("Topup.confirmRecharge")}
      renderTrigger={({ open }) => <RechargeTriggerButton onClick={open} label={triggerLabel} />}
      renderSheet={({ close }) => (
        <div className="flex-1 overflow-y-auto">
          {hasResult ? (
            <RechargeResultStep
              error={error}
              onBack={handleBack}
              onClose={() => {
                handleCancel();
                close();
              }}
            />
          ) : (
            <RechargeConfirmation
              {...summary}
              isLoading={isLoading}
              onConfirm={handleSubmit}
              onCancel={() => {
                handleCancel();
                close();
              }}
            />
          )}
        </div>
      )}
    />
  );
};

export default RechargeButtonMob;
